import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { MoleculeActionButtonModule } from '../../../../components/molecules/molecule-action-button/molecule-action-button.module';
import { ActionButton } from '../../../../models/action-button.model';
import { FiledDocumentsService } from '../../../features/filed-documents/shared/services/filed-documents/filed-documents.service';

@Component({
    selector: 'clmi-document-action-button',
    templateUrl: './action-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,

    imports: [MoleculeActionButtonModule],
})
export class DocumentActionButtonComponent {
    @Input() entityId: string;
    @Input() entityType: SystemEntity;

    constructor(private filedDocumentsService: FiledDocumentsService) {}

    get actionButton(): ActionButton {
        return this.filedDocumentsService.getAddDocumentActionButton(
            this.entityId,
            this.entityType,
        );
    }
}
